// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LabelWithStarIcon-module_wrapper_c5dab","skillsIcon":"LabelWithStarIcon-module_skillsIcon_5476a"};